import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

// Group thousands with a plain space (toLocaleString('fr-FR') emits a narrow
// no-break space that the PDF font renders as a "/").
const fmt = (n) => Math.round(Number(n) || 0)
  .toString()
  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export function generateEstimatePDF(estimate, vehicle = {}) {
  const doc = new jsPDF('p', 'mm', 'a4');
  const margin = 15;
  let y = 18;

  doc.setFontSize(16); doc.setTextColor(30, 30, 30);
  doc.text('Estimation de réparation — 1PARC', margin, y); y += 8;
  doc.setFontSize(10); doc.setTextColor(90, 90, 90);
  const veh = vehicle.plateNumber ? `${vehicle.plateNumber} — ${vehicle.brand || ''} ${vehicle.model || ''}` : '';
  doc.text(veh, margin, y); y += 6;
  doc.text(`Zone d'impact : ${estimate.impactSide || '—'}   Gravité : ${estimate.severity || '—'}`, margin, y); y += 6;

  autoTable(doc, {
    startY: y,
    head: [['Pièce', 'Qté', 'Meilleure offre', 'Marque', 'OEM', 'Économie']],
    body: estimate.lines.map((l) => {
      const saving = (l.oem && l.chosen && typeof l.oem.price === 'number' && typeof l.chosen.price === 'number')
        ? l.oem.price - l.chosen.price : null;
      return [
        l.label, String(l.qty),
        l.chosen ? `${fmt(l.chosen.price)} XOF` : 'à collecter',
        l.chosen ? (l.chosen.brand || '') : '',
        l.oem ? `${fmt(l.oem.price)} XOF` : '—',
        saving > 0 ? `- ${fmt(saving)} XOF` : '—',
      ];
    }),
    styles: { fontSize: 9 },
    headStyles: { fillColor: [41, 128, 185] },
  });

  let endY = doc.lastAutoTable.finalY + 8;
  doc.setFontSize(11); doc.setTextColor(30, 30, 30);
  doc.text('Comparatif pour l\'assurance', margin, endY); endY += 6;
  doc.setFontSize(10);
  doc.text(`Total pièces d'origine (OEM) : ${fmt(estimate.oemBaseline)} XOF`, margin, endY); endY += 5;
  doc.text(`Total pièces adaptables : ${fmt(estimate.aftermarketTotal)} XOF`, margin, endY); endY += 5;
  if (estimate.savingsAmount > 0 && estimate.savingsPct != null) {
    doc.setTextColor(0, 128, 0);
    doc.text(`Économie avec pièces adaptables : ${fmt(estimate.savingsAmount)} XOF (${estimate.savingsPct} %)`, margin, endY);
    doc.setTextColor(30, 30, 30); endY += 6;
  }
  doc.text(`Total estimé (meilleures offres) : ${fmt(estimate.estimateTotal)} XOF`, margin, endY);

  doc.save(`estimation-${vehicle.plateNumber || 'crash'}.pdf`);
}
